module.exports = __webpack_public_path__ + "img/john-harald-knutsson-p.8b944909.webp";